// @ts-nocheck
// Session positions gives the list of positions of the given session...

import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  tableCellClasses,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import styled from "@emotion/styled";

import {
  getFullDateStr,
  formatAMPM,
} from "../../../../../utils/methods/dateAndTimeMethods";
import { getCssVariableHandler } from "../../../../../utils/styles/getCssVariables";
import { handleDeletePosition } from "../sessionHandlers";

import EditIcon from "../../../../../assets/images/Edit-Square.svg";
import DeletePink from "../../../../../assets/images/Delete-pink.svg";
import styles from "../sessions.module.css";
import { CustomDialog } from "../../../../../components/Dialog/CustomDialog";
import { getSelectedOption } from "../../../../../utils/methods/formatters";
import { dateRegex } from "../../../../../utils/constants/dateRegex";
import RowsPerPageDropdown from "../../../../../components/Custom/Pagination/RowsPerPageDropdown";
import DotPagination from "../../../../../components/DotPagination/DotPagination";
import dayjs from "dayjs";
import { alertDialogAciton } from "../../../../../store/actions/auth";
import {
  deleteMultiplePositionAction,
  getSessionssOfSpecificEvent,
} from "../../../../../store/actions/createEvent";
import LoadingOverlay from "../../../../../components/Custom/LoadingOverlay";
import { OpenInNew } from "@mui/icons-material";
import SessionPositionEditableSheetOptimized from "../../event-details/SessionPositionEditableSheetOptimized";
import CustomHelper from "../../../../../components/Helper/CustomHelper";
import { isArray, isUndefined } from "lodash";
import { useCallback } from "react";
import { CustomIconButtonForSheet } from "../../../../../components/Custom/CustomIconButton";
import { KeyboardArrowDown } from "@mui/icons-material";
import { KeyboardArrowRight } from "@mui/icons-material";
import { useMemo } from "react";
import { shouldShowGroupedButton } from "../../../../../utils/methods/eventUtils";
import {
  collapseExpandedRow,
  expandCollapsedRow,
} from "../../../../../utils/methods/positionsTable/table";
import { isTimeTBD } from "../../../../../appCalcutions";
import { FRONTEND_CONFIG } from "../../../../../utils/constants/configs";
import MealOptionNotice from "../../../../../components/MealOptionNotice";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const SessionPositions = ({
  setInitialValues,
  viewAllSessionsPositions,
  getSessionOfPosition,
  session,
  sessionPositions,
  sessionPositionsUI,
  sessionPositionsStyles,
  handleEditPosition,
  eventInfo,
  setSearchTerm,
  resetForm,
  setEditId,
  refetchEventDetailsHandler,
  onClickViewPositions,
  openNewTab = false,
}) => {
  // static data start...
  // Structure and initial values of multiplePositionsForEdit state...
  const multiplePositionsForEditInit = React.useMemo(() => {
    return {
      data: [],
      // isAllSelected: this field will be true if all the positions of the current page are selected
      isAllSelected: false,
      isEditing: false,
    };
  }, []);

  const multiplePositionsInMultipleSessionsForEditInit = React.useMemo(() => {
    return {
      data: {
        positions: [],
      },
      // isAllSelected: this field will be true if all the positions of the current page are selected
      isAllSelected: false,
      isEditing: false,
    };
  }, []);
  // static data end...

  const dispatch = useDispatch();

  const auth = useSelector((store) => store.auth);
  const createContactInfo = useSelector((store) => store.createContactInfo);

  // State variables start...
  const [positionsTablePageNo, setPositionsTablePageNo] = useState(1);
  const [positionsTableLimit, setPositionsTableLimit] = useState(10);
  const [toBeDeletedSessionPosition, setToBeDeletedSessionPosition] =
    useState(null);
  const [sessionPositionsForCurrentPage, setSessionPositionsForCurrentPage] =
    useState([]);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  // const [multiplePositionsForEdit, setMultiplePositionsForEdit] =
  //   React.useState(multiplePositionsForEditInit);

  const [
    multiplePositionsInMultipleSessionsEdit,
    setMultiplePositionsInMultipleSessionsEdit,
  ] = React.useState(multiplePositionsInMultipleSessionsForEditInit);

  const [suffixData, setSuffixData] = useState({});
  const [dateChangedIdx, setDateChangedIdx] = React.useState(null);
  // State variables end...

  // Handlers start...
  const setupDeleteSessionPositionHandler = (sessionPosition) => {
    setToBeDeletedSessionPosition(sessionPosition);
  };

  const cancelDeleteSessionPositionHandler = () => {
    setToBeDeletedSessionPosition(null);
  };

  const deleteSessionPositionHandler = () => {
    handleDeletePosition({
      id: toBeDeletedSessionPosition?._id,
      data: toBeDeletedSessionPosition,
      eventInfo,
      dispatch,
      session,
      successCallback: () => {
        setToBeDeletedSessionPosition(null);
      },
      auth: eventInfo?.userId ? auth : null,
    });
  };

  const onEditMultiplePositionsHandler = () => {
    onCloseMultiplePositionsModal();
    refetchEventDetailsHandler();
  };

  const onCloseMultiplePositionsModal = () => {
    // setMultiplePositionsForEdit({
    //   ...multiplePositionsForEditInit,
    // });
    setMultiplePositionsInMultipleSessionsEdit({
      ...multiplePositionsInMultipleSessionsForEditInit,
    });
  };
  // Handlers end...

  const deleteMultiplePositionHandler = (positions) => {
    setIsDeleteLoading(true);
    const payload = (
      positions ?? multiplePositionsInMultipleSessionsEdit?.data?.positions
    )?.map((item) => ({
      id: item?._id,
      sessionId: item?.session?._id,
    }));
    const params = {
      eventId: eventInfo?._id,
    };
    dispatch(
      deleteMultiplePositionAction({
        payload: {
          positions: payload,
        },
        params,
        failureCallback: (error) => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message:
                error?.response?.data?.message ||
                "Failed to delete selected positions.",
            }),
          );
        },
        afterCallback: () => {
          setIsDeleteLoading(false);
        },
        successCallback: (response) => {
          setMultiplePositionsInMultipleSessionsEdit(
            multiplePositionsInMultipleSessionsForEditInit,
          );
          dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Success",
              message:
                response?.data?.message ||
                "Selected positions delete successfully.",
            }),
          );
        },
      }),
    );
  };

  function getDatePosName(pos) {
    const timeIn = isTimeTBD(pos?.timeIn)
      ? pos?.timeIn
      : dayjs(pos?.timeIn).format("HH:mm");
    const timeOut = isTimeTBD(pos?.timeOut)
      ? pos?.timeOut
      : dayjs(pos?.timeOut).format("HH:mm");
    return `${pos?.startDate}-${pos?.positionName}-${timeIn}-${timeOut}-${!isTimeTBD(pos?.timeIn) ? 0 : (pos?.numberOfHours ?? 0)}-${pos?.overNightShift ? "yes" : "no"}`;
  }

  function generateSuffixFor(pos) {
    return `${pos?.startDate}-${pos?.positionName}`;
  }

  const selectedSessionsListFromPositons = useMemo(() => {
    let list = new Set();
    createContactInfo?.sessionsOfEvent?.filter((item) => {
      multiplePositionsInMultipleSessionsEdit?.data?.positions?.forEach(
        (item) => {
          if (!list.has(item?.session?._id)) {
            list.add(item?.session?._id);
          }
        },
      );
    });

    return createContactInfo?.sessionsOfEvent?.filter((item) =>
      list?.has(item?._id),
    );
  }, [
    multiplePositionsInMultipleSessionsEdit?.data?.positions,
    createContactInfo?.sessionsOfEvent,
  ]);

  const isUnfoldAll = useMemo(() => {
    if (!dateChangedIdx) return false;

    let allUnfold = true;
    Object.values(dateChangedIdx || {})?.forEach((sessionData) => {
      if (!sessionData) return;
      Object.values(sessionData || {})?.forEach((item) => {
        if (!item?.status) {
          allUnfold = false;
        }
      });
    });
    return allUnfold;
  }, [dateChangedIdx]);

  // usecallback start...

  const unfoldLessHandler = useCallback(() => {
    setDateChangedIdx((prev) => {
      const updatedSession = { ...prev };
      Object.keys(updatedSession).forEach((dateKey) => {
        const sessionData = updatedSession[dateKey];
        Object.keys(sessionData).forEach((sessionKey) => {
          sessionData[sessionKey] = {
            ...sessionData[sessionKey],
            status: true,
          };
        });
      });
      return {
        ...updatedSession,
      };
    });
  }, [setDateChangedIdx]);

  const unfoldMoreHandler = useCallback(() => {
    setDateChangedIdx((prev) => {
      const updatedSession = { ...prev };
      Object.keys(updatedSession).forEach((dateKey) => {
        const sessionData = updatedSession[dateKey];
        Object.keys(sessionData).forEach((sessionKey) => {
          sessionData[sessionKey] = {
            ...sessionData[sessionKey],
            status: false,
          };
        });
      });
      return {
        ...updatedSession,
      };
    });
  }, [setDateChangedIdx]);

  const setCollapseAndExpandableData = useCallback(() => {
    let result = {};
    let suffix = {};
    let suffixMap = {};
    sessionPositionsForCurrentPage
      // ?.filter((item) => item?.session?._id === ses?._id)
      ?.forEach((pos, idx) => {
        const ses = pos?.session;
        const datePosId = getDatePosName(pos);
        const suffixId = generateSuffixFor(pos);
        if (!suffixMap?.[suffixId]) {
          suffixMap[suffixId] = {};
        }
        suffixMap[suffixId].count = (suffixMap?.[suffixId]?.count || 0) + 1;
        if (!suffixMap[suffixId]?._id) {
          suffixMap[suffixId]._id = [];
        }
        suffixMap[suffixId]?._id?.push(pos?._id);
        result[ses?._id] = {
          ...result?.[ses?._id],
          [datePosId]: {
            startIdx: result?.[ses?._id]?.[datePosId]
              ? result?.[ses?._id]?.[datePosId]?.startIdx
              : idx,
            endIdx: idx,
            count: (result?.[ses?._id]?.[datePosId]?.count || 0) + 1,
            status: FRONTEND_CONFIG?.groupedStatus,
            ids: result?.[ses?._id]?.[datePosId]?.ids
              ? [...(result?.[ses?._id]?.[datePosId]?.ids || []), pos?._id]
              : [pos?._id],
          },
        };
        if (isArray(result?.[ses?._id]?.[datePosId]?.Ids)) {
          result?.[ses?._id]?.[datePosId]?.Ids.push(pos?._id);
        } else {
          result[ses?._id][datePosId].Ids = [pos?._id];
        }
      });
    Object.keys(result).forEach((sessionId) => {
      result[sessionId] = Object.fromEntries(
        Object.entries(result[sessionId]).filter(
          ([_, value]) => value.count > 1,
        ),
      );
    });
    Object.keys(suffixMap).forEach((key) => {
      if (suffixMap[key].count === 1) {
        delete suffixMap[key];
      }
    });

    suffix = {};
    Object.entries(suffixMap).forEach(([_, value]) => {
      value._id?.forEach((id, idx) => {
        suffix[id] = idx + 1;
      });
    });
    setSuffixData(suffix);
    setDateChangedIdx((prev) => {
      const mergedResult = { ...prev };

      Object.keys(result).forEach((sessionId) => {
        if (!mergedResult[sessionId]) {
          mergedResult[sessionId] = {};
        }

        Object.entries(result[sessionId]).forEach(([datePosId, value]) => {
          if (mergedResult[sessionId][datePosId]) {
            mergedResult[sessionId][datePosId] = {
              ...mergedResult[sessionId][datePosId],
              ...value,
              status: isUndefined(prev[sessionId][datePosId].status)
                ? value.status
                : prev[sessionId][datePosId].status,
            };
          } else {
            mergedResult[sessionId][datePosId] = value;
          }
        });
        Object.entries(mergedResult[sessionId]).forEach(([datePosId, _]) => {
          if (
            mergedResult[sessionId][datePosId] &&
            !result?.[sessionId]?.[datePosId]
          ) {
            delete mergedResult[sessionId][datePosId];
          }
        });
      });

      return mergedResult;
    });
  }, [sessionPositionsForCurrentPage]);

  const isIndeterminateOnCollapse = useCallback(
    (posIds) => {
      const selectedCount = posIds?.filter((pos) =>
        multiplePositionsInMultipleSessionsEdit?.data?.positions?.some(
          (item) => item._id === pos,
        ),
      ).length;

      return selectedCount > 0 && selectedCount < posIds.length;
    },
    [multiplePositionsInMultipleSessionsEdit?.data?.positions],
  );

  const isAllSelected = useCallback(
    (posIds) => {
      return posIds?.every((pos) =>
        multiplePositionsInMultipleSessionsEdit?.data?.positions?.some(
          (item) => item._id === pos,
        ),
      );
    },
    [multiplePositionsInMultipleSessionsEdit?.data?.positions],
  );

  const collapsedCheckBoxClickAction = useCallback(
    (posIds, isAllSelected, indeterminated) => {
      if (isAllSelected || indeterminated) {
        setMultiplePositionsInMultipleSessionsEdit((prev) => ({
          ...prev,
          data: {
            ...prev?.data,
            positions: prev?.data?.positions?.filter(
              (pos) => !posIds?.includes(pos),
            ),
          },
        }));
      } else {
        setMultiplePositionsInMultipleSessionsEdit((prev) => ({
          ...prev,
          data: {
            ...prev.data,
            positions: Array.from(
              new Set([...(prev?.data?.positions || []), ...posIds]),
            ),
          },
        }));
      }
    },
    [setMultiplePositionsInMultipleSessionsEdit],
  );

  const showGroupBtn = useMemo(() => {
    return shouldShowGroupedButton({
      rows: sessionPositionsForCurrentPage,
      dateChangedIdx,
      getPosName: getDatePosName,
    });
  }, [dateChangedIdx, getDatePosName, sessionPositionsForCurrentPage]);

  // usecallback end...

  // useEffect start...
  useEffect(() => {
    // Updating sessionPositions with the current page's positions....
    const sessionPositionsForCurrentPageTemp = [
      ...[...sessionPositions]?.sort?.((a, b) => {
        if (a?.startDate != b?.startDate) {
          const startDateA = new Date(a?.startDate);
          const startDateB = new Date(b?.startDate);
          return startDateA - startDateB;
        } else if (
          a?.startDate == b?.startDate &&
          a?.positionId == b?.positionId
        ) {
          return a?.positionOrder - b?.positionOrder;
        } else return 0;
      }),
    ]?.filter?.((sessionPosition, sessionPositionIdx) => {
      return (
        sessionPositionIdx >=
          (positionsTablePageNo - 1) * positionsTableLimit &&
        sessionPositionIdx <
          (positionsTablePageNo - 1) * positionsTableLimit + positionsTableLimit
      );
    });

    setSessionPositionsForCurrentPage(sessionPositionsForCurrentPageTemp);
  }, [positionsTablePageNo, positionsTableLimit, sessionPositions]);

  useEffect(() => {
    if (
      sessionPositions?.length <=
      (positionsTablePageNo - 1) * positionsTableLimit
    ) {
      setPositionsTablePageNo((positionsTablePageNo) => {
        if (positionsTablePageNo > 1) {
          return positionsTablePageNo - 1;
        }
        return positionsTablePageNo;
      });
      return;
    }
  }, [sessionPositions?.length, positionsTablePageNo, positionsTableLimit]);

  React.useEffect(() => {
    if (!multiplePositionsInMultipleSessionsEdit?.isEditing) {
      return;
    }

    const data = {
      ...multiplePositionsInMultipleSessionsEdit?.data,
      positions: multiplePositionsInMultipleSessionsEdit?.data?.positions?.map(
        (position) => {
          return {
            ...position,
            dateStart: position?.startDate,
          };
        },
      ),
    };

    setMultiplePositionsInMultipleSessionsEdit(
      (multiplePositionsInMultipleSessionsEdit) => {
        return {
          ...multiplePositionsInMultipleSessionsEdit,
          data,
        };
      },
    );
  }, [multiplePositionsInMultipleSessionsEdit?.isEditing]);

  useEffect(() => {
    setCollapseAndExpandableData();
  }, [setCollapseAndExpandableData]);

  return (
    <>
      <MealOptionNotice rows={sessionPositions} />
      {sessionPositionsForCurrentPage?.length > 0 ? (
        <Grid
          sx={{
            width: "100% !important",
            paddingLeft: "0 !important",
          }}
        >
          <Box
            sx={{
              marginBottom: "0.5rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <Checkbox
                checked={multiplePositionsInMultipleSessionsEdit?.isAllSelected}
                indeterminate={
                  !multiplePositionsInMultipleSessionsEdit?.isAllSelected &&
                  multiplePositionsInMultipleSessionsEdit?.data?.positions
                    ?.length > 0
                }
                sx={{
                  padding: "0",
                  color: getCssVariableHandler({
                    variableName: "--font-rgb",
                  }),
                }}
                onChange={(e) => {
                  const isChecked = e.target.checked;

                  function deselectAll() {
                    setMultiplePositionsInMultipleSessionsEdit(
                      (multiplePositionsInMultipleSessionsEdit) => {
                        return {
                          ...multiplePositionsInMultipleSessionsEdit,
                          isAllSelected: false,
                          data: {
                            ...multiplePositionsInMultipleSessionsEdit?.data,
                            positions: [],
                          },
                        };
                      },
                    );
                  }

                  if (
                    !multiplePositionsInMultipleSessionsEdit?.isAllSelected &&
                    multiplePositionsInMultipleSessionsEdit?.data?.positions
                      ?.length > 0
                  ) {
                    deselectAll();
                    return;
                  }

                  if (!isChecked) {
                    deselectAll();
                  } else {
                    setMultiplePositionsInMultipleSessionsEdit(
                      (multiplePositionsInMultipleSessionsEdit) => {
                        return {
                          ...multiplePositionsInMultipleSessionsEdit,
                          isAllSelected: true,
                          data: {
                            ...multiplePositionsInMultipleSessionsEdit?.data,
                            positions: sessionPositionsForCurrentPage,
                          },
                        };
                      },
                    );
                  }
                }}
              />
              <Typography
                variant="h3"
                sx={{
                  fontSize: "20px",
                  // marginBottom: "12px"
                }}
              >
                Positions
              </Typography>
              {showGroupBtn ? (
                !isUnfoldAll ? (
                  <Button
                    sx={{
                      marginLeft: "10px",
                      background: getCssVariableHandler({
                        variableName: "--primary-pink-rgb",
                      }),
                      boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                      minWidth: "auto",
                      padding: "0.25rem 0.5rem",
                    }}
                    onClick={() => unfoldLessHandler()}
                  >
                    <Typography>Group</Typography>
                  </Button>
                ) : (
                  <Button
                    sx={{
                      marginLeft: "10px",
                      background: getCssVariableHandler({
                        variableName: "--primary-pink-rgb",
                      }),
                      boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                      minWidth: "auto",
                      padding: "0.25rem 0.5rem",
                    }}
                    onClick={() => unfoldMoreHandler()}
                  >
                    <Typography>Ungroup</Typography>
                  </Button>
                )
              ) : null}
            </Box>

            <Box sx={{ display: "flex", gap: "0.5rem" }}>
              {openNewTab ? (
                <Box>
                  <CustomHelper message={"View Positions"}>
                    {/* <Tooltip title={"View positions"}> */}
                    <Button
                      variant="text"
                      sx={{
                        backgroundColor: "white",
                        width: "2.5rem",
                        height: "2.5rem",
                        minWidth: "auto",
                        ":hover": {
                          backgroundColor: "white",
                          boxShadow: `0px 30px 80px 0px rgba(255, 0, 255, 0.30), 0px 0px 20px 0px ${getCssVariableHandler({ variableName: "--primary-pink-rgb" })} inset`,
                        },
                      }}
                      onClick={(e) => {
                        e?.stopPropagation();
                        if (onClickViewPositions) {
                          onClickViewPositions();
                        }
                      }}
                    >
                      <OpenInNew />
                    </Button>
                    {/* </Tooltip> */}
                  </CustomHelper>
                </Box>
              ) : null}
              {multiplePositionsInMultipleSessionsEdit?.data?.positions
                ?.length > 0 ? (
                <CustomHelper message={"Edit multiple position"}>
                  <Button
                    variant="text"
                    sx={{
                      backgroundColor: "#C369A7",
                      padding: "10px 10px",
                      width: "auto",
                      minWidth: "auto",
                      ":hover": {
                        backgroundColor: "#C369A7",
                      },
                    }}
                    onClick={() => {
                      // setSelectedRow(row);
                      // setPositionModal({
                      //   data: row,
                      //   state: true,
                      // });
                      setMultiplePositionsInMultipleSessionsEdit(
                        (multiplePositionsInMultipleSessionsEdit) => {
                          return {
                            ...multiplePositionsInMultipleSessionsEdit,
                            isEditing: true,
                          };
                        },
                      );
                    }}
                  >
                    <img src={EditIcon} alt="" />
                  </Button>
                </CustomHelper>
              ) : null}

              {multiplePositionsInMultipleSessionsEdit?.data?.positions
                ?.length > 0 ? (
                <CustomHelper message={"Delete multiple positions"}>
                  <Button
                    variant="text"
                    sx={{
                      backgroundColor: "#fff",
                      padding: "10px 10px",
                      width: "auto",
                      minWidth: "auto",
                      ":hover": {
                        backgroundColor: "#fff",
                      },
                    }}
                    onClick={() => {
                      dispatch(
                        alertDialogAciton({
                          open: true,
                          title: "Warning",
                          message:
                            "Are you sure, you want to delete these selected positions?",
                          onOk: () => {
                            deleteMultiplePositionHandler();
                          },
                          okLabel: "Delete",
                        }),
                      );
                    }}
                  >
                    <img src={DeletePink} alt="" />
                  </Button>
                </CustomHelper>
              ) : null}
            </Box>
          </Box>
          <Box
            sx={{
              border: "1px solid #D175B6",
              borderRadius: "8px",
              minHeight: "200px",
              position: "relative,",
            }}
            className={styles.addContractorsTable}
          >
            {isDeleteLoading ? <LoadingOverlay open={isDeleteLoading} /> : null}
            <Box
              sx={{
                // border: "1px solid #D175B6",
                // background: "#000000",
                // borderRadius: "8px",
                overflow: "auto",
              }}
            >
              <TableContainer
                className="custom-scroll-design"
                sx={{
                  maxHeight:
                    sessionPositionsStyles?.tableContainer?.maxHeight ||
                    "300px",
                }}
              >
                <Table
                  sx={{
                    backgroundColor: "transparent !important",
                  }}
                  aria-label="sticky table"
                  stickyHeader
                >
                  <TableHead
                    sx={{
                      backgroundColor: "#000 !important",
                    }}
                  >
                    <TableRow
                      sx={{
                        "& th": {
                          backgroundColor: "#000 !important",
                          padding: "2px 15px",
                          fontSize: "14px",
                          color: "#ffffff",
                          borderColor: "#D175B6",
                          "& span": {
                            color: "#ffffff !important",
                          },
                        },
                      }}
                    >
                      <StyledTableCell sx={{ whiteSpace: "nowrap" }}>
                        <TableSortLabel disabled>Sr No.</TableSortLabel>
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          width: viewAllSessionsPositions ? "30%" : "22.5%",
                        }}
                      >
                        <TableSortLabel disabled>Position</TableSortLabel>
                      </StyledTableCell>

                      <StyledTableCell>
                        <TableSortLabel disabled>Qty</TableSortLabel>
                      </StyledTableCell>
                      {viewAllSessionsPositions ? (
                        <StyledTableCell
                          sx={{
                            width: "22.5%",
                            textAlign: "center",
                          }}
                        >
                          Session
                        </StyledTableCell>
                      ) : null}
                      <StyledTableCell
                        sx={{
                          width: viewAllSessionsPositions ? "25%" : "20%",
                        }}
                      >
                        <TableSortLabel disabled>Time</TableSortLabel>
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          width: viewAllSessionsPositions ? "30%" : "20%",
                        }}
                      >
                        <TableSortLabel disabled>MP/WA</TableSortLabel>
                      </StyledTableCell>
                      {/* <StyledTableCell
                        sx={{
                          width: "10%",
                        }}
                      >
                        <TableSortLabel>Quantity</TableSortLabel>
                      </StyledTableCell> */}
                      <StyledTableCell
                        sx={{
                          width: "15%",
                          textAlign: "end",
                        }}
                      >
                        Actions
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      "& td": {
                        borderColor: "#D175B6",
                        color: "#ffffff",
                        "& p": {
                          fontSize: "14px",
                        },
                        "& td": {},
                      },
                    }}
                  >
                    {sessionPositionsForCurrentPage?.map((item, index) => {
                      const dpName = getDatePosName(item);
                      const {
                        startIdx,
                        endIdx,
                        count,
                        status,
                        ids: Ids,
                      } = dateChangedIdx?.[item?.session?._id]?.[dpName] || {};
                      const indeterminateStatus =
                        isIndeterminateOnCollapse(Ids);
                      const collapsedSelectedAll = isAllSelected(Ids);

                      if (status && index > startIdx && index <= endIdx) {
                        return null;
                      }
                      return (
                        <React.Fragment key={item?._id}>
                          {index === 0 ||
                          getFullDateStr(
                            sessionPositionsForCurrentPage?.[index]?.startDate,
                          ) !==
                            getFullDateStr(
                              sessionPositionsForCurrentPage?.[index - 1]
                                ?.startDate,
                            ) ? (
                            <StyledTableRow
                              sx={{
                                backgroundColor: "transparent !important",
                                width: "100%",
                                "& td": {
                                  padding: "0.5rem",
                                },
                              }}
                            >
                              <StyledTableCell colSpan={10}>
                                <Typography
                                  sx={{
                                    color: "white",
                                  }}
                                >
                                  {/* {getFormattedFullDate(item?.timeIn)} */}
                                  {dayjs(item?.startDate)?.format?.("ddd")}{" "}
                                  {dayjs(item?.startDate)?.format?.(
                                    "MM/DD/YYYY",
                                  )}
                                  {/* {formatDateWithHyphen(item?.startDate)} */}
                                </Typography>
                              </StyledTableCell>
                            </StyledTableRow>
                          ) : null}
                          <StyledTableRow
                            key={index}
                            sx={{
                              width: "100%",
                              "& td": {
                                padding: "0.5rem !important",
                                paddingTop: "0.25rem !important",
                                paddingBottom: "0.25rem !important",
                              },
                              ...(item?.isBackupPosition
                                ? {
                                    backgroundColor: `${getCssVariableHandler({
                                      variableName: "--backup-position-color",
                                    })} !important`,
                                  }
                                : {
                                    backgroundColor: "#000 !important",
                                  }),
                            }}
                          >
                            <StyledTableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                <Checkbox
                                  sx={{
                                    padding: "0",
                                    color: getCssVariableHandler({
                                      variableName: "--font-rgb",
                                    }),
                                  }}
                                  checked={
                                    status
                                      ? collapsedSelectedAll
                                      : Boolean(
                                          multiplePositionsInMultipleSessionsEdit?.data?.positions?.find(
                                            (position) => {
                                              return (
                                                position?._id === item?._id
                                              );
                                            },
                                          ),
                                        )
                                  }
                                  indeterminate={
                                    status ? indeterminateStatus : false
                                  }
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    if (status) {
                                      collapsedCheckBoxClickAction(
                                        sessionPositions?.filter((pos) =>
                                          Ids?.includes(pos?._id),
                                        ),
                                        collapsedSelectedAll,
                                        indeterminateStatus,
                                      );
                                    } else {
                                      if (isChecked) {
                                        setMultiplePositionsInMultipleSessionsEdit(
                                          (
                                            multiplePositionsInMultipleSessionsEdit,
                                          ) => {
                                            return {
                                              ...multiplePositionsInMultipleSessionsEdit,
                                              data: {
                                                ...multiplePositionsInMultipleSessionsEdit?.data,
                                                positions: [
                                                  ...(multiplePositionsInMultipleSessionsEdit
                                                    ?.data?.positions || []),
                                                  item,
                                                ],
                                              },
                                            };
                                          },
                                        );
                                      } else {
                                        setMultiplePositionsInMultipleSessionsEdit(
                                          (
                                            multiplePositionsInMultipleSessionsEdit,
                                          ) => {
                                            return {
                                              ...multiplePositionsInMultipleSessionsEdit,
                                              data: {
                                                ...multiplePositionsInMultipleSessionsEdit?.data,
                                                positions:
                                                  multiplePositionsInMultipleSessionsEdit?.data?.positions?.filter(
                                                    (position) => {
                                                      return (
                                                        position?._id !==
                                                        item?._id
                                                      );
                                                    },
                                                  ),
                                              },
                                            };
                                          },
                                        );
                                      }
                                    }
                                  }}
                                />
                                <Typography
                                  sx={{
                                    fontSize: "1rem",
                                  }}
                                >
                                  {index + 1}
                                </Typography>
                                {startIdx === index ? (
                                  status ? (
                                    <CustomIconButtonForSheet
                                      sx={{
                                        backgroundColor:
                                          "transparent !important",
                                        outline: "1px solid #D175B6",
                                      }}
                                      onClick={() => {
                                        expandCollapsedRow({
                                          setDateChangedIdx,
                                          row: item,
                                          dpName,
                                        });
                                      }}
                                    >
                                      <KeyboardArrowRight
                                        sx={{ fontSize: "1.25rem" }}
                                      />
                                    </CustomIconButtonForSheet>
                                  ) : (
                                    <CustomIconButtonForSheet
                                      sx={{
                                        backgroundColor:
                                          "transparent !important",
                                        outline: "1px solid #D175B6",
                                      }}
                                      onClick={() => {
                                        collapseExpandedRow({
                                          setDateChangedIdx,
                                          row: item,
                                          dpName,
                                        });
                                      }}
                                    >
                                      <KeyboardArrowDown
                                        sx={{ fontSize: "1.25rem" }}
                                      />
                                    </CustomIconButtonForSheet>
                                  )
                                ) : (
                                  <Box
                                    sx={{
                                      height: "1.5rem",
                                      aspectRatio: "1",
                                      display: "inline-flex",
                                    }}
                                  ></Box>
                                )}
                              </Box>
                            </StyledTableCell>
                            <StyledTableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                <Typography
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    "& a": {
                                      lineHeight: "0",
                                    },
                                    "& img": {
                                      marginRight: "10px",
                                    },
                                    fontSize: "1rem !important",
                                  }}
                                >
                                  {`${item?.positionName}${!status ? (item?.positionOrder ? "-" + item?.positionOrder : "") : ""}`}
                                </Typography>
                              </Box>
                            </StyledTableCell>

                            <StyledTableCell>
                              <Typography
                                sx={{
                                  marginLeft: "1rem",
                                }}
                              >
                                {status ? count : 1}
                              </Typography>
                            </StyledTableCell>
                            {viewAllSessionsPositions ? (
                              <StyledTableCell>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      textAlign: "center",
                                      "& a": {
                                        lineHeight: "0",
                                      },
                                      "& img": {
                                        marginRight: "10px",
                                      },
                                      fontSize: "1rem !important",
                                    }}
                                  >
                                    {item?.session?.sessionName}
                                  </Typography>
                                </Box>
                              </StyledTableCell>
                            ) : null}
                            <StyledTableCell sx={{}}>
                              <Typography
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  "& a": {
                                    lineHeight: "0",
                                  },
                                  "& img": {
                                    marginRight: "10px",
                                  },
                                  fontSize: "1rem !important",
                                }}
                              >
                                {!dateRegex.test(
                                  item?.timeIn?.split?.("T")?.[0],
                                )
                                  ? `TBD (${item?.numberOfHours} ${item?.numberOfHours > 1 ? "hours" : "hour"})`
                                  : `${
                                      dateRegex.test(
                                        item?.timeIn?.split?.("T")?.[0],
                                      )
                                        ? formatAMPM(item?.timeIn)
                                        : "TBD"
                                    } - ${
                                      dateRegex.test(
                                        item?.timeOut?.split?.("T")?.[0],
                                      )
                                        ? formatAMPM(item?.timeOut)
                                        : "TBD"
                                    }`}
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell>
                              <Typography
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  "& a": {
                                    lineHeight: "0",
                                  },
                                  "& img": {
                                    marginRight: "10px",
                                  },
                                  fontSize: "1rem !important",
                                }}
                              >
                                {getSelectedOption(item?.selectOption)}
                              </Typography>
                            </StyledTableCell>
                            {/* <StyledTableCell
                              sx={{
                                textAlign: "center",
                              }}
                            >
                              {item.quantity}
                            </StyledTableCell> */}
                            <StyledTableCell
                              sx={{
                                // marginTop: "10px",
                                gap: "10px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                  marginRight: "0.5rem",
                                }}
                              >
                                <CustomHelper
                                  index={index}
                                  message={"Edit position"}
                                >
                                  <Button
                                    variant="text"
                                    sx={{
                                      backgroundColor: "#C369A7",
                                      padding: "5px",
                                      width: "auto",
                                      minWidth: "auto",
                                      ":hover": {
                                        backgroundColor: "#C369A7",
                                      },
                                    }}
                                    onClick={() => {
                                      if (status) {
                                        setMultiplePositionsInMultipleSessionsEdit(
                                          (prev) => ({
                                            ...prev,
                                            isEditing: true,
                                            data: {
                                              ...prev?.data,
                                              positions:
                                                sessionPositions?.filter(
                                                  (pos) =>
                                                    Ids?.includes(pos?._id),
                                                ),
                                            },
                                          }),
                                        );
                                      } else {
                                        handleEditPosition({
                                          id: item?._id,
                                          data: item,
                                          setSearchTerm,
                                          resetForm,
                                          setEditId,
                                          setInitialValues,
                                          dispatch,
                                        });

                                        if (getSessionOfPosition) {
                                          getSessionOfPosition({
                                            positionId: item?._id,
                                          });
                                        }
                                      }
                                    }}
                                  >
                                    <img
                                      src={EditIcon}
                                      alt=""
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                  </Button>
                                </CustomHelper>
                                <CustomHelper
                                  index={index}
                                  message={"Delete position"}
                                >
                                  <Button
                                    size="small"
                                    variant="text"
                                    sx={{
                                      backgroundColor: "#fff",
                                      padding: "5px",
                                      width: "auto",
                                      minWidth: "auto",
                                      ":hover": {
                                        backgroundColor: "#fff",
                                      },
                                    }}
                                    onClick={() => {
                                      dispatch(
                                        alertDialogAciton({
                                          open: true,
                                          title: "Warning",
                                          message:
                                            "Are you sure, you want to delete these positions?",
                                          okLabel: "Delete",
                                          onOk: () => {
                                            deleteMultiplePositionHandler(
                                              status
                                                ? sessionPositions?.filter(
                                                    (pos) =>
                                                      Ids?.includes(pos?._id),
                                                  )
                                                : [item],
                                            );
                                          },
                                        }),
                                      );
                                    }}
                                  >
                                    {sessionPositionsUI?.deleteSessionPositionLoading &&
                                    item?._id ===
                                      toBeDeletedSessionPosition?._id ? (
                                      <CircularProgress
                                        size={22}
                                        style={{
                                          color: "black",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={DeletePink}
                                        alt=""
                                        style={{
                                          width: "18px",
                                          height: "18px",
                                        }}
                                      />
                                    )}
                                  </Button>
                                </CustomHelper>
                              </Box>
                            </StyledTableCell>
                          </StyledTableRow>
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                sx={{
                  position: "relative",
                  height: "2.5rem !important",
                  display: "flex",
                  justifyContent: "center",
                  borderTop: `1px solid ${getCssVariableHandler({ variableName: "--primary-pink-hex" })}`,
                  // gap: "0.25rem",
                  "& td": {
                    display: "block",
                  },
                }}
              >
                <DotPagination
                  currPage={positionsTablePageNo}
                  setCurrPage={setPositionsTablePageNo}
                  valueLen={sessionPositions?.length || 0}
                  valueOnPerPage={positionsTableLimit}
                  addOne={false}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: "48%",
                    right: "0.5rem",
                    transform: "translateY(-50%)",
                    // height: "4rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <RowsPerPageDropdown
                    value={positionsTableLimit}
                    onChange={(e) => {
                      setPositionsTableLimit(e?.target?.value);
                      setPositionsTablePageNo(1);
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      ) : null}
      <CustomDialog
        open={Boolean(toBeDeletedSessionPosition?._id)}
        onClose={cancelDeleteSessionPositionHandler}
        isLoading={
          createContactInfo?.sessionPositionsUI?.deleteSessionPositionLoading
        }
        title={`Are you sure you want to delete this position?`}
        onOk={() => {
          deleteSessionPositionHandler();
        }}
      />
      {/* NOTE: edit multiple positions */}
      {/* {multiplePositionsInMultipleSessionsEdit?.isEditing ? ( */}
      {/*   <ManagePositionsForMultipleSessions */}
      {/*     timezone={eventInfo?.eventTimezone} */}
      {/*     isPreview={true} */}
      {/*     data={multiplePositionsInMultipleSessionsEdit?.data} */}
      {/*     eventInfo={eventInfo} */}
      {/*     open={multiplePositionsInMultipleSessionsEdit?.isEditing} */}
      {/*     successCallback={() => { */}
      {/*       refetchEventDetailsHandler(); */}
      {/*       dispatch({ */}
      {/*         type: ALERT_DIALOG, */}
      {/*         payload: { */}
      {/*           open: true, */}
      {/*           title: `Success!`, */}
      {/*           message: `Positions edited successfully!`, */}
      {/*         }, */}
      {/*       }); */}
      {/*     }} */}
      {/*     handleClose={() => { */}
      {/*       console.log("handleClose"); */}
      {/*       setMultiplePositionsInMultipleSessionsEdit({ */}
      {/*         ...multiplePositionsInMultipleSessionsForEditInit, */}
      {/*       }); */}
      {/*     }} */}
      {/*   /> */}
      {/* ) : null} */}
      {multiplePositionsInMultipleSessionsEdit?.isEditing ? (
        <SessionPositionEditableSheetOptimized
          eventInfo={eventInfo}
          data={multiplePositionsInMultipleSessionsEdit?.data?.positions}
          session={session}
          sessions={
            viewAllSessionsPositions
              ? selectedSessionsListFromPositons
              : [session]
          }
          open={multiplePositionsInMultipleSessionsEdit?.isEditing}
          handleClose={() => {
            setMultiplePositionsInMultipleSessionsEdit({
              ...multiplePositionsInMultipleSessionsForEditInit,
            });
          }}
          hideSessions={true}
          isEditMultiple={true}
          isManagePositions={false}
          allowCopyPositions
        />
      ) : null}
      {/* <Modal
          open={Boolean(toBeDeletedSessionPosition?._id)}
          onClose={cancelDeleteSessionPositionHandler}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        > 
          <Box
            sx={{
              width: '70vw',
              height: '70vh'
            }}
          >
            <ReusableParentContainer 
              style={{
                width: '100%',
                height: '100%',
                background: 'rgb(0, 0, 0)'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '1.5rem'
                }}
              >
                <Typography
                  variant="h4"
                >
                  Are you sure you want to perform this action?
                </Typography>

                <Box 
                  className={styles.bottomBtn}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem'
                  }}
                >
                  <Button
                    className={styles.BtnPosition}
                    onClick={() => {
                      // submitForm();
                      deleteSessionPositionHandler();
                    }}
                    // sx={{
                    //   backgroundColor: `rgb(0, 0, 0) !important`
                    // }}
                  >
                    {createContactInfo?.sessionPositionsUI?.deleteSessionPositionLoading ? (
                      <CircularProgress size={22} />
                    ) : "Confirm"}
                  </Button>

                  <Button
                    className={styles.BtnPosition}
                    sx={{
                      backgroundColor: `${getCssVariableHandler({
                        variableName: `--primary-pink-hex`
                      })} !important`
                    }}
                    onClick={() => {
                      cancelDeleteSessionPositionHandler();
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </ReusableParentContainer>
          </Box>
        </Modal> */}
    </>
  );
};

SessionPositions.propTypes = {
  setInitialValues: PropTypes.func,
  viewAllSessionsPositions: PropTypes.any,
  getSessionOfPosition: PropTypes.any,
  session: PropTypes.any,
  sessionPositions: PropTypes.any,
  sessionPositionsUI: PropTypes.any,
  sessionPositionsStyles: PropTypes.any,
  handleEditPosition: PropTypes.any,
  eventInfo: PropTypes.any,
  setSearchTerm: PropTypes.any,
  resetForm: PropTypes.any,
  setEditId: PropTypes.any,
  refetchEventDetailsHandler: PropTypes.any,
  onClickViewPositions: PropTypes.any,
  openNewTab: PropTypes.any,
};

export default SessionPositions;
